// SettingsPage.jsx
import React, { useContext, useState } from 'react';
import { Container, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import {
  FaLock, FaBell, FaShieldAlt, FaSignOutAlt, FaChevronRight, FaArrowLeft, FaUserSlash
} from 'react-icons/fa';
import '../../../../assets/css/customer/subscreens/account/UserSettings.css';
import BottomNavigation from '../../../../components/general/bottomnavigation/BottomNavigation';
import AppContext from "../../../../contexts/AppContext";
import MyNavbar from '../../../../components/general/mynavbar/MyNavbar';
import axios from 'axios';

import LegalOptionsModal from '../../account/customersettings/legaloptions/LegalOptionModal';
// Terms & Conditions ab Settings mein Privacy Policy jaisa full page hai (navigate se khulega)
// Purana TermsModal sirf Signup page pe use hoga, waha koi change nahi karna

const SettingsPage = () => {
  const navigate = useNavigate();
  const { logout, customer, baseUrl } = useContext(AppContext);

  // Legal & Policies ke liye choice modal ka state
  const [showLegalOptions, setShowLegalOptions] = useState(false);

  const handleLogout = () => {
    Swal.fire({
      title: 'Logout',
      text: 'Are you sure you want to logout?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#FF8559',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, Logout',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      customClass: {
        popup: 'logout-sweet-alert',
        confirmButton: 'logout-confirm-btn',
        cancelButton: 'logout-cancel-btn'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        logout();

        Swal.fire({
          title: 'Logged Out!',
          text: 'You have been successfully logged out.',
          icon: 'success',
          confirmButtonColor: '#FF8559',
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          navigate('/login');
        });
      }
    });
  };

  const handleDeleteAccount = () => {
    Swal.fire({
      title: 'Delete Account',
      text: 'Are you sure you want to delete your account? You will not be able to login again, and this email cannot be used to create a new account.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, Delete My Account',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      customClass: {
        popup: 'delete-sweet-alert',
        confirmButton: 'delete-confirm-btn',
        cancelButton: 'delete-cancel-btn'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        // Backend call — yeh endpoint account ko "archive" karega (data delete nahi hoga)
        const formdata = new FormData();
        formdata.append("customer_id", customer?.id);

        axios
          .post(`${baseUrl}/customer/deleteAccount`, formdata, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then(() => {
            Swal.fire({
              title: 'Account Deleted',
              text: 'Your account has been deleted successfully.',
              icon: 'success',
              confirmButtonColor: '#FF8559',
              timer: 1800,
              showConfirmButton: false
            }).then(() => {
              logout();
              navigate('/login');
            });
          })
          .catch((error) => {
            Swal.fire({
              title: 'Something went wrong',
              text: error.response?.data?.message || 'Unable to delete account. Please try again.',
              icon: 'error',
              confirmButtonColor: '#FF8559'
            });
          });
      }
    });
  };

  // Policies card ab is function ko call karega - naya action 'legal'
  const handleOpenLegalOptions = () => {
    setShowLegalOptions(true);
  };

  const handleSelectPrivacy = () => {
    setShowLegalOptions(false);
    navigate('/settings/privacy');
  };

  const handleSelectTerms = () => {
    setShowLegalOptions(false);
    navigate('/settings/terms');
  };

  const settingsOptions = [
    {
      icon: FaLock,
      title: 'Change Password',
      description: 'Update your password regularly for security',
      path: '/settings/change-password',
      color: '#FF8559',
      action: 'navigate',
      mobileOnly: false
    },
    {
      icon: FaBell,
      title: 'Notifications',
      description: 'View your notifications',
      path: '/settings/notifications',
      color: '#FF8559',
      action: 'navigate',
      mobileOnly: true
    },
    {
      icon: FaShieldAlt,
      title: 'Terms & Privacy',
      description: 'Privacy Policy and Terms & Conditions',
      color: '#FF8559',
      action: 'legal',
      mobileOnly: false
    },
    {
      icon: FaSignOutAlt,
      title: 'Logout',
      description: 'Sign out of your account',
      color: '#FF8559',
      action: 'logout',
      mobileOnly: false
    },
    {
      icon: FaUserSlash,
      title: 'Delete Account',
      description: 'Permanently delete your account',
      color: '#dc3545',
      action: 'delete',
      mobileOnly: false
    }
  ];

  const handleOptionClick = (option) => {
    if (option.action === 'navigate') {
      navigate(option.path);
    } else if (option.action === 'logout') {
      handleLogout();
    } else if (option.action === 'delete') {
      handleDeleteAccount();
    } else if (option.action === 'legal') {
      handleOpenLegalOptions();
    }
  };

  return (
    <>
      <MyNavbar />
      <div className="settings-page">
        <Container>
          <div className="account-shell-container">
            <div className="settings-header">
              <button className="back-btn" onClick={() => navigate('/account')}>
                <FaArrowLeft size={20} />
              </button>
              <h1>Settings</h1>
              <div></div>
            </div>

            <div className="settings-list">
              {settingsOptions.map((option, index) => {
                let cardClass = `settings-option-card${option.action === 'delete' ? ' delete-option' : ''}`;
                if (option.mobileOnly === true) {
                  cardClass += ' settings-option-mobile-only';
                }
                return (
                  <Card
                    key={index}
                    className={cardClass}
                    onClick={() => handleOptionClick(option)}
                  >
                    <div className="settings-option-content">
                      <div
                        className="settings-option-icon"
                        style={{ backgroundColor: `${option.color}15`, color: option.color }}
                      >
                        <option.icon size={24} />
                      </div>
                      <div className="settings-option-text">
                        <h4>{option.title}</h4>
                        <p>{option.description}</p>
                      </div>
                    </div>
                    <FaChevronRight className="settings-option-arrow" />
                  </Card>
                );
              })}
            </div>
          </div>
          <BottomNavigation />
        </Container>
      </div>

      {/* Legal & Policies choice modal */}
      <LegalOptionsModal
        show={showLegalOptions}
        onClose={() => setShowLegalOptions(false)}
        onSelectPrivacy={handleSelectPrivacy}
        onSelectTerms={handleSelectTerms}
      />
    </>
  );
};

export default SettingsPage;